module.exports = __webpack_public_path__ + "static/media/p6ZOrOr.b0f662b4.png";